import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { CreditCard } from "lucide-react";

const Banner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 14px 20px;
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  border: 1px solid #f59e0b;
  color: #92400e;
  font-size: 14px;
  font-weight: 500;
`;

const Text = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  background: #b45309;
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: #92400e;
  }
`;

export function TrialExpiredBanner() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Banner role="alert">
      <Text>
        <CreditCard size={20} aria-hidden />
        {t("billing.trialExpiredBanner")}
      </Text>
      <Button type="button" onClick={() => navigate("/billing")}>
        <CreditCard size={16} />
        {t("billing.upgradeToContinue")}
      </Button>
    </Banner>
  );
}

export default TrialExpiredBanner;
